import { usePostRelease } from '../api/release-api/release-api';
import { ReleaseDto } from '../api/model';
import { useQueryClient } from '@tanstack/react-query';

export const usePostReleaseCreate = () => {
  const postReleaseMutation = usePostRelease();
  const queryClient = useQueryClient();

  const createRelease = async (releaseData: ReleaseDto) => {
    try {
      const response = await postReleaseMutation.mutateAsync({ data: releaseData });

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['/release'] }),
        queryClient.invalidateQueries({ queryKey: ['/project'] }),
        queryClient.invalidateQueries({ queryKey: ['projects'] }),
      ]);

      if (releaseData.projectId) {
        await queryClient.invalidateQueries({ 
          queryKey: [`/release/${releaseData.projectId}/project`]
        });
      }
      
      return response;
    } catch (error) {
      // Callers already show a toast on failure; avoid double-notifying
      throw error;
    }
  };

  return {
    createRelease,
    isLoading: postReleaseMutation.isPending,
    error: postReleaseMutation.error
  };
};